import BaseController from './baseSystemController';
import ControllerDisplayRTP from './infoPanel/ControllerDisplayRTP';
import ControllerStopwatch from './infoPanel/ControllerStopwatch';
import ControllerNetPosition from './infoPanel/ControllerNetPosition';
import ControllerGameState from './infoPanel/ControllerGameState';
import ControllerClock from './infoPanel/ControllerClock';
import ControllerBalanceInfo from './infoPanel/ControllerBalanceInfo';
import eInfoPanelControllerTypes from './infoPanel/eInfoPanelControllerTypes';
import logo from '../../../assets/images/onlyplay_logo_white.svg'
import ScaleManager from '../../../scaleManager/ScaleManager';

export default class ControllerInfoPanel extends BaseController {
  constructor({ container, ...props }) {
    super({ ...props });
    this._eControllersClasses = {
      [this.controllerTypes.EIT_STOPWATCH]: ControllerStopwatch,
      [this.controllerTypes.EIT_GAME_STATE]: ControllerGameState,
      [this.controllerTypes.EIT_NET_POSITION]: ControllerNetPosition,
      [this.controllerTypes.EIT_DISPLAY_RTP]: ControllerDisplayRTP,
      [this.controllerTypes.EIT_BALANCE]: ControllerBalanceInfo,
      [this.controllerTypes.EIT_CLOCK]: ControllerClock,
    }

    this._eElementsTypes = {
      EET_CONTAINER: 'container',
    };

    this._container = container;
    this._playerBalance = 0;
  }

  init() {
    if (this._mounted) return;

    this._needInitControllers = {
      [this.controllerTypes.EIT_STOPWATCH]: OPWrapperService.config.infoPanel.showStopwatch,
      [this.controllerTypes.EIT_GAME_STATE]: OPWrapperService.config.infoPanel.showGameState,
      [this.controllerTypes.EIT_NET_POSITION]: OPWrapperService.config.infoPanel.showNetPosition,
      [this.controllerTypes.EIT_DISPLAY_RTP]: OPWrapperService.config.infoPanel.displayRtp,
      [this.controllerTypes.EIT_BALANCE]: OPWrapperService.config.infoPanel.showBalanceInfo,
      [this.controllerTypes.EIT_CLOCK]: true,
    }

    Object.values(this.controllerTypes)
      .forEach(infoType => {
        if (!this._needInitControllers[infoType]) {
          this._excludedControllerTypes.add(infoType);
        } else {
          this._eElementsTypes[infoType] = infoType;
        }
      });

    super.init(this._container);
    if (this.controllers[this.controllerTypes.EIT_BALANCE]) this.controllers[this.controllerTypes.EIT_BALANCE].updateBalance(this._playerBalance);
    this.scaleData = { scaleData: this._scaleData };
  }

  updateBalanceInfo(balance) {
    if (this._excludedControllerTypes.has(this.controllerTypes.EIT_BALANCE)) return;

    if (!this._mounted) {
      this._playerBalance = balance;
      return;
    }

    this.controllers[this.controllerTypes.EIT_BALANCE].updateBalance(balance);
  }

  get controllerTypes() {
    return eInfoPanelControllerTypes;
  }

  _tryCreateMarkupItemByInfoType(infoType) {
    if (!this._excludedControllerTypes.has(infoType)) {
      return `<span id="${this.interactiveElementsIds[infoType]}"></span>`
    } else {
      return '';
    }
  }

  set scaleData({ scaleData, rootScale }) {
    this._scaleData = scaleData;
    if (!this._mounted) return;

    this.interactiveElements[this._eElementsTypes.EET_CONTAINER].dataset.orientation = scaleData.isPortrait ? 'portrait' : 'landscape';
    this.interactiveElements[this._eElementsTypes.EET_CONTAINER].dataset.deviceType = scaleData.isMobile ? 'mobile' : 'desktop';
    if (ScaleManager.config.BIND_TO_TOP) {
      this.interactiveElements[this._eElementsTypes.EET_CONTAINER].dataset.bindTo = 'top';
    }
  }

  _getMarkup() {
    return `
    <div class="system-ui-container__info_panel">
      <div id=${this.interactiveElementsIds[this._eElementsTypes.EET_CONTAINER]} class="system-ui-container__info_panel__container">
        ${OPWrapperService.config.infoPanel.hideGameTitle ? '' :
      `<span class="system-ui-container__info_panel__container__game_title__portrait">${document.title}</span>`}
        
        <div class="system-ui-container__info_panel__container__info">
          <div class="system-ui-container__info_panel__container__info__list">
            ${this._tryCreateMarkupItemByInfoType(this.controllerTypes.EIT_STOPWATCH)}
            ${this._tryCreateMarkupItemByInfoType(this.controllerTypes.EIT_NET_POSITION)}
            ${this._tryCreateMarkupItemByInfoType(this.controllerTypes.EIT_GAME_STATE)}
            ${this._tryCreateMarkupItemByInfoType(this.controllerTypes.EIT_DISPLAY_RTP)}
            ${this._tryCreateMarkupItemByInfoType(this.controllerTypes.EIT_BALANCE)}
          </div>
          <div class="system-ui-container__info_panel__container__info__static">
            ${OPWrapperService.config.infoPanel.hideGameTitle ? '' : `<span class="system-ui-container__info_panel__container__game_title__landscape">${document.title}</span>`}
            <img class="system-ui-container__info_panel__container__logo" src="${logo}" alt="logo">
            <!-- clock -->
            <div id="${this.interactiveElementsIds[this.controllerTypes.EIT_CLOCK]}"></div>
          </div>
        </div>
      </div>
    </div>`
  }
}
